import { featureFlagsActions } from 'app-components/flux/feature-flags';
import { getBuildConfig } from 'app-components/utils/core';
import { takeEvery } from 'redux-saga/effects';
import mixpanel, { initialApiHost } from 'utils/core/mixpanel';

function* mixpanelUpdateApiHost() {
  yield takeEvery(featureFlagsActions.applyFeatureFlagsChanges, function* updateApiHost({ payload: flags }) {
    if (!(flags?.mixpanelProxy === undefined)) {
      mixpanel.set_config({ api_host: (flags.mixpanelProxy && getBuildConfig()?.mixpanelProxy) || initialApiHost });
    }
  });
}

export default [mixpanelUpdateApiHost];
